var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography, useTheme } from "@mui/material";
import { memo } from "react";
import { DataGridPro, GridRow, GridCell, } from "@mui/x-data-grid-pro";
var MemoizedRow = memo(GridRow);
var MemoizedCell = memo(GridCell);
export var DataTable = function (_a) {
    var rows = _a.rows, columns = _a.columns, title = _a.title;
    var theme = useTheme();
    return (_jsxs(Box, __assign({ sx: {
            width: "100%",
            padding: "8px 16px",
            background: theme.palette.common.white,
            boxShadow: theme.shadows[1],
            borderRadius: 2,
        } }, { children: [title && (_jsx(Box, __assign({ mb: 1 }, { children: _jsx(Typography, __assign({ color: "text.secondary", variant: "body2" }, { children: title })) }))), _jsx(DataGridPro, { getRowHeight: function () { return "auto"; }, disableRowSelectionOnClick: true, autoHeight: true, throttleRowsMs: 3000, columns: columns, rows: rows, initialState: { pagination: { paginationModel: { pageSize: 10 } } }, pageSizeOptions: [10, 25, 100], pagination: true, slots: {
                    row: MemoizedRow,
                    cell: MemoizedCell,
                }, sx: {
                    width: "100%",
                    color: "text.primary",
                    border: "none",
                    "& .app-header": {
                        fontSize: "14px",
                        lineHeight: "16px",
                        whiteSpace: "nowrap",
                        outline: "none",
                    },
                    "& .app-header:focus": {
                        outline: "none",
                    },
                    "& .MuiDataGrid-columnHeader": {
                        p: 2,
                    },
                    "& .MuiDataGrid-cell": {
                        p: 2,
                        alignItems: "start",
                    },
                    "& .MuiDataGrid-cell:focus": {
                        outline: "none",
                    },
                    "& .breakSpacesCell": {
                        whiteSpace: "break-spaces",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                    },
                    "& .nowrapCell": {
                        whiteSpace: "nowrap",
                        textOverflow: "ellipsis",
                        overflow: "hidden",
                    },
                    "& p": {
                        margin: 0,
                    },
                } })] })));
};
